import { Outlet } from 'react-router-dom';
import { useScrollOnNavigate } from '../hooks/useScrollOnNavigate';
import Navbar from './Navbar';
import Footer from './Footer';

function Layout() {
  useScrollOnNavigate();

  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default Layout;
